export enum RateType {
  Fixed = 1,
  Discount = 2,
  Variable = 3,
  Tracker = 4,
  Lifetime = 5,
  SteppedFixed = 6,
  TrackerSonia = 7,
}
